import { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Typography,
} from '@mui/material';
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase.js";

export default function ModalDialog({ classCode, open, onClose, sign, mode, handleChange, school, language }) {
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");
  const [deadline, setDeadline] = useState("");

  useEffect(() => {
    setTitle("");
    setText("");
    setDeadline("");
  }, [open]);

  const handleSubmit = async () => {
    const docRef = doc(db, school, classCode);
    const docSnap = await getDoc(docRef);
    const data = docSnap.data();
    const field = mode === "task" ? "tasks" : "homeworks";
    const items = { ...data[field] };

    if (sign === "-") {
      if (!items[title]) {
        setTitle(!language ? "Չկա նման տարր" : "No such element");
        return;
      }
      delete items[title];
      handleChange(`removed from ${mode === "task" ? "tasks" : "subjects"}`);
    } else {
      if (items[title]) {
        setTitle(!language ? "Արդեն կա" : "Already exists");
        return;
      }
      items[title] = mode === "task"
        ? { text, deadline }
        : { text: "" };
      handleChange(`added to ${mode === "task" ? "tasks" : "subjects"}`);
    }

    await updateDoc(docRef, { [field]: items });
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3},
      }}
      disableEnforceFocus={false} 
    >
      <DialogTitle>
        <Typography variant="h6" fontWeight={600}>
          {(sign === "-")
            ? (mode === "task" ? !language ? "Առաջադրանքի Հեռացում" : "Remove a Task" : !language ? "Առարկայի Հեռացում" : "Remove a Subject")
            : (mode === "task" ? !language ? "Առաջադրանքի Ավելացում" : "Add a Task" : !language ? "Առարկայի Ավելացում" : "Add a Subject")}
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 1 }}>
        <TextField
          fullWidth
          label={mode === "task" ? !language ? "Վերնագիր" : "Titile" : !language ? "Անվանում" : "Name"}
          placeholder={mode === "task" ? !language ? "Վերնագիր" : "Titile" : !language ? "Անվանում" : "Name"}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          sx={{ mb: 2 }}
        />

        {sign === "+" && mode === "task" && (
          <Box display="flex" flexDirection="column" gap={2}>
            <TextField
              fullWidth
              label={!language ? "Նկարագրություն" : "Description"}
              multiline
              rows={3}
              placeholder={!language ? "Նկարագրություն" : "Description"}
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
            <TextField
              fullWidth
              label={!language ? "Վերջնաժամկետ" : "Deadline"}
              placeholder={!language ? "Օրինակ՝ 2025-06-01" : "Example: 2025-06-01"}
              value={deadline}
              onChange={(e) => setDeadline(e.target.value)}
            />
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{
            borderRadius: 2,
            px: 3,
            bgcolor: '#26b8b8',
            '&:hover': { bgcolor: '#1ea0a0' },
          }}
        >
          {language ? 'Save' : 'Հաստատել'}
        </Button>
        <Button
          onClick={onClose}
          sx={{ borderRadius: 2, bgcolor: '#ffffff' }}
        >
          {language ? 'Cancel' : 'Փակել'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
